const messages = {
    researches: {
        type: 'researches',
        emptyMessage: 'нет данных исследований, поэтому они не отображены.',
        errorMessage: 'недоступны данные исследований. Они будут загружены при восстановлении связи.',
    },
    perforation: {
        type: 'perforation',
        emptyMessage: 'нет данных о перфорации, поэтому они не отображены.',
    },
    reports: {
        type: 'reports',
        emptyMessage: 'нет данных по отчетам, поэтому они не отображены.',
        errorMessage: 'не получены отчеты РИГИС. Они будут загружены при восстановлении связи.',
    },
    rigis: {
        type: 'rigis',
        emptyMessage: 'нет данных по отчетам, поэтому они не отображены.',
    },
    fgi: {
        type: 'fgi',
        emptyMessage: 'нет данных по ФГИ, поэтому они не отображены.',
    },
    geoObjects: {
        type: 'geoObjects',
        emptyMessage: 'нет данных по геологичским объектам, поэтому они не отображены.',
    },
};

export default messages;
